/**
 * Converts a camelCase key to kebab-case.
 * e.g. "isSubmitting" → "is-submitting", "hasValue" → "has-value"
 */
function camelToKebab(str) {
  return str.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`);
}

/**
 * Converts a state mapping object into data-attribute props.
 * - boolean `true` → `data-{key}="true"`
 * - boolean `false`, `null`, `undefined` → attribute omitted
 * - string/number → `data-{key}="{value}"`
 *
 * Keys are converted from camelCase to kebab-case to produce
 * valid lowercase data attributes (e.g. `isSubmitting` → `data-is-submitting`).
 */
export function getDataAttributes(state) {
  const result = {};
  for (const [key, value] of Object.entries(state)) {
    if (value === undefined || value === null || value === false) {
      continue;
    }
    result[`data-${camelToKebab(key)}`] = String(value);
  }
  return result;
}